import styled from 'styled-components';

export const LeasedFilterContainer = styled.div`
  label {
    cursor: pointer;
    height: 54px;
    border-radius: 14px;
    border: 1px solid ${({ theme }) => theme.colors.border.primary};

    &::after {
      display: none;
    }

    @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      padding: 0;
      height: 45px;
      border: none;
    }
  }

  label:nth-child(1) {
    margin-bottom: 15px;

    @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
      margin: 0;
    }
  }
`;
